import React from "react";
import { Image as ImageIco } from "lucide-react";

/**
 * Small poster thumbnail rendered on the LEFT of a horizontal event/news card.
 *
 * Always visible so members can recognise the poster at-a-glance in the list.
 * The full-size poster is still revealed on demand via the "Show poster"
 * toggle (see useCardExpansion in individual pages).
 */
export function CardThumb({ src, alt, className = "" }) {
  if (!src) {
    return (
      <div
        className={`shrink-0 bg-white flex items-center justify-center text-muted-foreground ${className}`}
        aria-hidden
      >
        <ImageIco className="h-6 w-6 opacity-50" />
      </div>
    );
  }
  return (
    <div className={`shrink-0 bg-white overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt || ""}
        className="w-full h-full object-contain"
        loading="lazy"
      />
    </div>
  );
}
